//디바이스 체크 유틸

export const isIOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

export const isAndroid = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android/i.test(userAgent);
}

/**
 * 현재 환경이 위챗 미니앱인지 확인
 * 일단 환자앱에 있는 deviceCheck를 가져옴...
 * 장기적으로 병원앱에도 isMiniApp이 필요한 지는 조금 미지수라 일단 주석처리
 */
// export const isMiniapp = () => {
//     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//     if (/wechat/i.test(userAgent) || /miniProgram/i.test(userAgent)) {
//         return true;
//     }
//     return false;
// }

/**
 * 현재 환경이 병원앱 iOS/Android인지, 혹은 카카오톡, 기타앱의 인앱브라우저인지 확인
 */
//TODO: App/Web 둘 다 고도화된 규격으로 유저에이전트를 다뤄야 함
// App이 "CERTILIFE_USER_AGENT_PREFIX / valueA / valueB / valueC / CERTILIFE_USER_AGENT_SUFFIX" 형태로 보내게 수정을 하면
// Web, Server는 위 규격에서 필요한 값을 가져다 쓰게끔 하게끔 고도화 되어야 함
export const isCertilifeHostApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (userAgent.includes('CERTILIFE_USER_AGENT')) {
        return true
    } else {
        return false
    }
}
/**
 * 호스트앱이 알려 온 자기 버전. 앱이 아니거나 안 알려주면 null.
 *
 * 앱은 UA 마커 뒤에 "CERTILIFE_USER_AGENT/1.0.4" 처럼 버전을 붙인다.
 *
 * store 의 appVersion(= window.setAppVersion 브리지)이 아니라 UA 를 보는 이유는
 * 타이밍이다. 브리지는 페이지 로드가 끝난 뒤(onPageFinished / didFinish)에 값을
 * 넣는데, 라우터의 '/' 리다이렉트는 그보다 먼저 한 번만 실행된다. 그 시점에
 * store 를 보면 신버전 앱도 값이 비어 있어 구버전으로 오판한다.
 * UA 는 언제 읽어도 같은 값이라 그 문제가 없다.
 *
 * 브리지는 그대로 둔다 — 마이페이지의 '버전 정보' 행이 그 값을 쓴다.
 */
export const getHostAppVersion = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
    const matched = userAgent.match(/CERTILIFE_USER_AGENT\/([0-9][0-9.]*)/);
    return matched ? matched[1] : null;
};

/**
 * 네이티브 하단 탭을 갖고 있는 구버전 앱인가.
 *
 * 구버전 앱은 UA 마커만 보내고 버전은 안 보낸다 — 버전을 싣는 코드가 이번
 * 버전에서 처음 들어갔기 때문이다. 그래서 '앱인데 버전이 없다' 가 곧 구버전이다.
 *
 * 이 값이 true 면 웹은 폰 전용 요소를 그리지 않고 예전 동선을 그대로 쓴다.
 * 웹 하단 탭까지 그리면 네이티브 탭과 두 줄로 겹치기 때문이다.
 *
 * 앱이 아니면(모바일 브라우저·PC) 항상 false 라 영향이 없다.
 *
 * 스토어의 구버전이 충분히 줄어들면 이 분기는 통째로 지운다.
 */
export const isLegacyHostApp = () => isCertilifeHostApp() && !getHostAppVersion();

/*
 * ─────────────────────────────────────────────────────────────────────────────
 * 앱이 「자기가 그리는 네이티브 크롬」을 UA 로 신고한다 — CERTILIFE_UI/<토큰,토큰>
 *
 *   AOS   ... android CERTILIFE_USER_AGENT/1.3.0 CERTILIFE_UI/no-header
 *   iOS   ... CERTILIFE_USER_AGENT/1.1.0 CERTILIFE_UI/no-header userInterfaceIdiom 0
 *
 * ── 왜 버전 숫자로 가르지 않는가 ──
 *   isLegacyHostApp() 은 「앱인데 버전이 없다」는 1비트로 갈랐다. 그 비트는 버전을 싣는
 *   코드가 그 릴리스에서 처음 들어갔기 때문에 성립했고, 지금은 양쪽 앱이 다 버전을 보내
 *   소진됐다. 숫자 비교로 대체하면 바로 아래 needsAppUpdate 주석이 적어 둔 문제가 그대로 온다 —
 *   플랫폼마다 상수가 생기고, 앱을 낼 때마다 웹을 다시 배포해야 한다.
 *
 *   네이티브 뷰의 존재는 hasNativeScanner 처럼 직접 물을 방법이 없다. 그래서 앱이 신고한다.
 *
 * ── 방향이 중요하다 ──
 *   토큰은 「그린다」가 아니라 **「안 그린다」** 를 신고한다. 신고가 없으면 「모른다」가 아니라
 *   「예전대로 그린다」로 읽어, 판정이 어긋나도 겹치는 쪽이 아니라 안전한 쪽으로 떨어진다.
 *   덕분에 웹을 앱보다 먼저 배포해도 구버전 앱에 아무 일이 없다.
 *
 * ── 이름에 chrome 을 쓰면 안 된다 ──
 *   inapi 의 qr-code.service.ts 가 /chrome/i 로 브라우저를 집계한다(대소문자 무시).
 *   CERTILIFE_CHROME 같은 이름을 붙이면 iOS 앱 트래픽이 크롬으로 잘못 잡힌다 —
 *   에러 없이 통계만 틀어진다. UA 를 읽는 곳을 먼저 확인하고 이름을 정한다.
 *
 * ── 토큰 목록 ──
 *   no-header   상단 로고 바를 앱이 그리지 않는다   AOS 1.3.0 · iOS 1.1.0 부터
 *
 * ── 정리 순서 ──
 *   구버전이 소멸하면 **웹의 검사를 먼저 지우고**(= 앱이면 무조건 웹이 그린다) 그 배포가
 *   반영된 뒤에 앱의 토큰을 지운다. 앱부터 지우면 양쪽 다 안 그려 헤더가 사라진다.
 *   (앱 토큰은 25자라 굳이 지울 이유도 없다.)
 * ─────────────────────────────────────────────────────────────────────────────
 */

/**
 * 앱이 신고한 크롬 토큰 목록. 앱이 아니거나 신고가 없으면 빈 배열.
 */
const getHostAppChrome = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
    const matched = userAgent.match(/CERTILIFE_UI\/([a-z0-9,-]+)/i);
    return matched ? matched[1].toLowerCase().split(',') : [];
};

/**
 * 앱이 상단 로고 바를 자기가 그리는가.
 *
 * 앱이 'no-header' 로 「안 그린다」고 명시했을 때만 false 다.
 * 모바일 브라우저·PC 는 앱이 아니므로 항상 false — 웹이 그린다(지금까지와 같다).
 *
 * 이 값이 true 인 동안 웹은 헤더를 그리지 않고 본문 위 여백도 주지 않는다
 * (App.vue 의 showMobileHomeBar 하나가 헤더 표시와 본문 여백을 함께 정한다).
 */
export const appDrawsNativeHeader = () =>
    isCertilifeHostApp() && !getHostAppChrome().includes('no-header');

/**
 * 앱이 네이티브 스캐너를 내어 주는가.
 *
 * ── 「앱인가?」를 묻지 않는 이유 ──
 *   isCertilifeHostApp() 은 UA 에 표식이 있는지만 본다. 그래서 스토어에 이미 깔린
 *   구버전 앱도 참이 된다. 그 앱에는 스캔 메서드가 없으므로, 앱이라는 이유로
 *   네이티브를 부르면 아무 반응 없이 화면이 멈춘다.
 *
 *   그래서 **그 메서드가 실제로 있는지** 를 묻는다. 버전 표를 관리할 필요가 없고,
 *   앱이 메서드를 추가하는 순간 그 기기부터 저절로 켜진다.
 *   웹을 먼저 배포해도 아무 일이 없다 — 메서드가 없으니 웹 카메라가 그대로 쓰인다.
 *
 * ── 두 플랫폼이 메서드를 내어 주는 방식 ──
 *   안드로이드  addJavascriptInterface(WebViewBridge(), "WebViewBridge") 로 심은 객체에
 *               @JavascriptInterface 를 붙인 메서드만 노출된다
 *   iOS         userContentController.add(handler, name:) 로 등록한 이름만
 *               window.webkit.messageHandlers 에 생긴다
 *
 * @param {string} method 예: 'requestWebToApp_ScanQR_Label'
 */
export const hasNativeScanner = (method) =>
    typeof window.WebViewBridge?.[method] === 'function'
    || !!window.webkit?.messageHandlers?.[method];

/**
 * 앱인데 그 스캔 메서드가 없다 — 사용자가 앱을 업데이트해야 한다.
 *
 * ── 왜 버전을 보지 않는가 ──
 *   버전은 대리 지표다. 「1.2.0 이상이면 스캔이 될 것이다」라는 가정이 들어간다.
 *   우리가 알고 싶은 것은 「이 앱이 스캔을 할 수 있는가」이고, 그것은 메서드가
 *   있는지 보면 **직접** 알 수 있다. 물을 수 있으면 묻는 편이 낫다.
 *
 *   isLegacyHostApp() 이 버전을 보는 것은 그쪽에서는 직접 물을 방법이 없기
 *   때문이다 — 네이티브 하단 탭의 존재는 웹이 감지할 수 없다.
 *
 *   버전으로 가리면 ① 웹에 최소 버전 상수를 박아 앱을 낼 때마다 웹을 다시 배포해야
 *   하고 ② 두 플랫폼의 버전 체계가 달라 상수가 둘이 되며(AOS 1.1.9 · iOS 1.0.4)
 *   ③ 버전을 싣기 전에 나간 앱은 값 자체가 없어 판정할 수 없다. 메서드를 보면 셋 다 없다.
 *
 * ── 왜 「앱인가」를 함께 보는가 ──
 *   메서드만 보면 **브라우저와 구버전 앱이 똑같이 거짓**이다. 브라우저는 웹 카메라로
 *   잘 도는 환경이라 막으면 안 되고, 구버전 앱은 막아야 한다. 두 질문이 필요하다.
 *
 *       브라우저    앱 아님 · 메서드 없음   →  웹 카메라
 *       구버전 앱   앱     · 메서드 없음   →  업데이트 안내   ← 이 함수가 참
 *       신버전 앱   앱     · 메서드 있음   →  네이티브
 *
 * ── 배포 순서를 강제한다 ──
 *   이 안내가 켜지면 **앱이 스토어에 올라간 뒤에 웹을 내야 한다.** 거꾸로 하면
 *   앱 사용자 전원이 「업데이트하세요」를 보는데 받을 업데이트가 없다.
 *
 * @param {string} method 예: 'requestWebToApp_ScanQR_Label'
 */
export const needsAppUpdate = (method) =>
    isCertilifeHostApp() && !hasNativeScanner(method);
